import React from 'react';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga4';
import './Footer.css';

const Footer = () => {
  const handleRequestAccessClick = () => {
    ReactGA.event({
      category: 'user_engagement',
      action: 'early_access_click',
      label: 'footer_button'
    });
  };

  return (
    <footer className="footer">
      <div className="page-container">
        <div className="footer-top">
          <Link to="/" className="footer-brand" aria-label="Circumvent home">
            <img
              src="/images/circumvent-logo-cloud.png"
              alt=""
              width={180}
              height={40}
              className="footer-brand__logo"
            />
          </Link>

          <div className="footer-columns">
            <div className="footer-col">
              <h2 className="footer-col__heading">Product</h2>
              <ul className="footer-col__list">
                <li>
                  <Link to="/solutions">Solutions</Link>
                </li>
                <li>
                  <Link to="/solutions/agents">Agents</Link>
                </li>
              </ul>
            </div>

            <div className="footer-col">
              <h2 className="footer-col__heading">Company</h2>
              <ul className="footer-col__list">
                <li>
                  <Link to="/#about">About</Link>
                </li>
                <li>
                  <Link to="/trust">Trust Center</Link>
                </li>
                <li>
                  <Link to="/#contact">Contact</Link>
                </li>
              </ul>
            </div>

            <div className="footer-col">
              <h2 className="footer-col__heading">Resources</h2>
              <ul className="footer-col__list">
                <li>
                  <Link to="/blog">
                    Blog
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer-cta">
            <Link
              to="/#contact"
              className="btn btn-gradient footer-cta__btn"
              onClick={handleRequestAccessClick}
            >
              Request Access
            </Link>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-start">
            <div className="footer-social" aria-label="Social links">
              <a
                href="https://x.com/Circumventsec"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social__link"
                aria-label="X (Twitter)"
              >
                <img
                  src="/images/social/social_logo_X.svg"
                  alt=""
                  width={40}
                  height={40}
                  className="footer-social__img"
                  decoding="async"
                />
              </a>
              <a
                href="https://www.linkedin.com/company/circumventsecurity/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social__link"
                aria-label="LinkedIn"
              >
                <img
                  src="/images/social/social_logo_in.svg"
                  alt=""
                  width={40}
                  height={40}
                  className="footer-social__img"
                  decoding="async"
                />
              </a>
            </div>
            <Link
              to="/blog/soc-2-type-1-compliance"
              className="footer-trust-badge"
              aria-label="SOC 2 Type 1 compliance. Read announcement."
            >
              <img
                src="/images/blog/soc2-type1-sensiba-badge-white.png"
                alt="Sensiba SOC 2 Type 1"
                width={268}
                height={124}
                className="footer-trust-badge__img"
                loading="lazy"
                decoding="async"
              />
            </Link>
          </div>

          <div className="footer-legal">
            <Link to="/privacy" className="footer-legal__link">
              Privacy Policy
            </Link>
            <span className="footer-legal__copy">
              &copy; {new Date().getFullYear()} Circumvent. All rights reserved
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
